import * as React from 'react';
import { IStylingFirm, IProduct } from '../Entities';
import { FormGroup, ControlLabel, Row, Col, Button } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import FormValidationService from '../../../shared/form/FormValidationService';

import FormSelect from '../../../components/common/FormSelect';

interface IStylingFirmsProductFormProps {
    stylingFirm: IStylingFirm;
    availableProducts: IProduct[];
    selectedProduct: IProduct;
    errors: any;
    addProduct(): any;
    deleteProduct(id: number): any;
    selectedProductChanged(e: React.FormEvent<HTMLInputElement>): any;
}

const StylingFirmsProductForm = (props: IStylingFirmsProductFormProps) => {
    let selectableProducts = props.availableProducts.filter((product: IProduct) => {
        for (var i = 0; i < props.stylingFirm.products.length; i++) {
            const elm = props.stylingFirm.products[i];
            if (product.id == elm.id) {
                return false;
            }
        }
        return true;
    });

    return (
        <>
            <Row style={{ marginTop: 25 }}>
                <Col md={8}>
                    <FormGroup
                        validationState={FormValidationService.getValidationState(
                            props.errors.name
                        )}
                    >
                        <FormSelect
                            name="product"
                            value={props.selectedProduct.id}
                            onChange={props.selectedProductChanged}
                        >
                            <option value="-1">
                                -- {Translate('styling-firms/modal/select-label/filter-product')} --
                            </option>
                            {selectableProducts &&
                                selectableProducts.map((product: IProduct) => {
                                    return (
                                        <option key={product.id} value={product.id}>
                                            {product.name}
                                        </option>
                                    );
                                })}
                        </FormSelect>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <Button
                        className="pull-right"
                        onClick={props.addProduct}
                        bsStyle="success"
                        disabled={props.selectedProduct.id === -1}
                    >
                        {Translate('styling-firms/modal/control-button/add-product')}
                    </Button>
                </Col>
            </Row>

            <table className="table table-hover table-responsive">
                <thead>
                    <tr>
                        <th>
                            <ControlLabel>
                                {Translate('styling-firms/modal/product/tableheader/picked')}{' '}
                            </ControlLabel>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {props.stylingFirm.products &&
                        props.stylingFirm.products.map((product: IProduct) => {
                            return (
                                <tr key={product.id}>
                                    <td>{product.name}</td>
                                    <td>
                                        <Button
                                            className="pull-right"
                                            onClick={() => {
                                                props.deleteProduct(product.id);
                                            }}
                                            bsStyle="danger"
                                        >
                                            {Translate(
                                                'styling-firms/modal/control-button/delete-product'
                                            )}
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </>
    );
};

export default StylingFirmsProductForm;
